import { createSelector } from 'reselect'
import { getSessionView } from '../reducks/sessions'

export const sessionMetadata = createSelector([getSessionView], view => {
  return {
    currentState: view.current_state,
    disabled: view.disabled,
    availabilitySet: view.has_availability,
    unreadIrMessages: view.unread_message_count,
    emailPreferencesAccessTokenKey: view.email_preferences_access_token_key,
  }
})
